import { render, staticRenderFns } from "./VibrationsFFT.vue?vue&type=template&id=3822ae0a&scoped=true&"
import script from "./VibrationsFFT.vue?vue&type=script&lang=js&"
export * from "./VibrationsFFT.vue?vue&type=script&lang=js&"
import style0 from "./VibrationsFFT.vue?vue&type=style&index=0&id=3822ae0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822ae0a",
  null
  
)

export default component.exports